import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { TaskModel } from "@core/api/models/course/task-model";
import { CourseTaskQuestion, CourseTaskQuestionAdapter } from '@core/models/course/course-task-question.model';

export class CourseTask{
    constructor(
      public id:string,
      public name:string = "",
      public description:string = "",
      public type:string = "",
      public remarks:string = "",
      public score:string = "",
      public deadline:Date|null = null,
      public turnedInDate:Date|null = null,
      public passed:boolean = false,
      public late:boolean = false,
      public fileName:string = "",
      public filePath:string = "",
      public status:'new'|'done' = 'new',
      public feedbackSummary:boolean = false,
      public feedbackPerQuestion:boolean = false,
      public questions: CourseTaskQuestion[] = [],
      public maxAttemptsReached: boolean = false,
      public seriesId:string = '',
      public sessionId:string = '',
      public visibleFromDate:Date|null,
      public visibleFrom:'before'|'after'|'date',
      public disclaimer:string = "",
      public mustAcceptDisclaimer:boolean = false
    ){}

    getIcon(){
      switch (this.type) {
        case "file":
          return "upload_file";
        case "form":
          return "quiz";
        default:
          return "task_alt";
      }
    }

    getStatus(){

      let result = { type:'button', label:'task.turn-in', class:'accent'};
      if(this.type == 'quotation'){
        result.type = '';
      }
      if(this.type == 'form'){
        result.label ='start';
      }

      if(this.late){
        result.type = "label";
        result.label = "task.passed-deadline";
        result.class = "warning";
      }else if(!this.passed && this.score && this.turnedInDate && this.maxAttemptsReached){
        result.type="label";
        result.class="warning";
        result.label ="not-passed";
      }else if(this.passed){
        result.type="label";
        result.class="success";
        result.label ="passed";
      }else if(this.turnedInDate){

        const now = new Date().getTime();
        if(this.deadline && (this.deadline?.getTime() < now)){
          result.type = "label";
          result.class = "accent";
          result.label = "task.turned-in";
        }else{
          if (this.maxAttemptsReached) {
            result.class = "accent";
            result.type = "label";
            result.label = "task.turned-in";
          } else {
            result.class = "accent";
            result.type = "button";
            result.label =  this.type == 'form' ? "start" : "task.resubmit";
          }
        }

      }

      return result;
    }
  }


@Injectable({
  providedIn: 'root'
})
export class CourseTaskAdapter implements Adapter<CourseTask> {
  constructor(private questionAdapter: CourseTaskQuestionAdapter){}
  adapt(item: TaskModel): CourseTask {
    let task = new CourseTask(
      item.id,
      item.name,
      item.description,
      item.type,
      item.remarks,
      item.score,
      item.deadline?new Date(item.deadline):null,
      item.submittedAt?new Date(item.submittedAt):null,
      item.result == 'passed',
      item.result == 'late',
      item.file?item.file.name:'',
      item.file?item.file.url:'',
      item.status,
      item.showFeedbackAfterSubmit,
      item.showFeedbackAfterAnswer,
      item.questions.map(this.questionAdapter.adapt.bind(this.questionAdapter)),
      item.maxAttemptsReached,
      item.series,
      item.session??'',
      item.visibleFromDate ?? null,
      item.visibleFrom,
      item.disclaimer,
      item.mustAcceptDisclaimer
    );

    if(item.answers && item.answers.questions){
      
      task.questions.forEach(question => {
        const answerDB = item.answers.questions.find((x:any) => x.question.id == question.id);
        if(answerDB){
          question.score = answerDB.answer ? answerDB.answer.score : 0;
          if(question.type =='open'){
            question.openAnswer = answerDB.answer;
          }else{
            if(answerDB.answer){
              question.options.forEach(opt => {
                if(Array.isArray(answerDB.answer)){
                  answerDB.answer.forEach((item:any) => {
                    if(item.id == opt.id){
                      opt.selected = true;
                      opt.score = item.score;
                    }
                  })
                } else {
                  opt.selected = answerDB.answer.id == opt.id;
                  opt.score = answerDB.answer.score;
                }
              });
            }
          }
        }
      });

      }
    
    return task;
  }
}
